defineDs('DanskeSpil/Domain/NumberGames/Scripts/Templates/MultiClient/Client/Flow/JokerMultiplierSelector',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
  ],
  // eslint-disable-next-line no-unused-vars
  function (m, Utils) {
    const JokerMultiplierSelector = {
      controller: function ({ gameModel, jokerOption }) {
        const selectMultiplier = (multiplier) => {
          gameModel.jokerRowsMultiplier(multiplier);
          gameModel.save();
        };

        const jokerDates = gameModel.jokerDrawDates(jokerOption).map((date) => {
          return new Date(date.closingTime);
        });
        const formattedDates = jokerDates.map((date) => {
          return Utils.getLongDate(date, true);
        });

        return { gameModel, selectMultiplier, formattedDates };
      },
      view: function ({ gameModel, selectMultiplier, formattedDates }, { jokerRowsMultiplierOptions }) {
        return (<div className='joker-multiplier-selector'>
          <div className='joker-multiplier-selector__options'>
            {jokerRowsMultiplierOptions.map((multiplierOption) => {
              const isSelected = multiplierOption === gameModel.jokerRowsMultiplier();
              return (<div
                className={`joker-multiplier-selector__option ${isSelected ? 'selected' : ''}`}
                key={multiplierOption}
                onclick={() => selectMultiplier(multiplierOption)}>
                <span className='joker-multiplier-selector__option-value'>
                  <span>×</span>
                  <span>{multiplierOption}</span>
                </span>
              </div>);
            })}
          </div>
          <div className='joker-multiplier-selector__games-list'>
            {formattedDates.map((date) => {
              return (<div className='joker-multiplier-selector__game-date' key={date}>
                <span className='joker-multiplier-selector__game-date-label'>{gameModel.jokerRowsMultiplier()} × Joker</span>
                <span className='joker-multiplier-selector__game-date-value'>{date}</span>
              </div>);
            })}
          </div>
        </div>);
      }
    };

    return JokerMultiplierSelector;
  });